import type { IPushBridge } from './ports/IPushBridge'

// Сценарий: выход — токен устройства перестаёт действовать, пуши прежнему продавцу не приходят
// (notifire выключит устройство при следующей отправке: FCM ответит, что токена нет).
export class ForgetPushDevice {
  constructor(private readonly bridge: IPushBridge) {}

  execute() {
    if (this.bridge.isAvailable()) this.bridge.deleteToken()
  }
}
